import CompareVertical from "./CompareVertical.page";

export default CompareVertical;
